import {
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
} from "@mui/material";
import { FC, useContext } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";

import { LoginAuthType, loginParamsAtom } from "@ryde/shared";

import { LoginPageFormContext } from "../login.page.form.context";
import { useLoginTranslation } from "../use-login-translation";
import { getRadioButtonLoginSx } from "./login.parts.styled";

interface ILoginTypeSwitchProps {
  name: string;
}

export const LoginTypeSwitch: FC<ILoginTypeSwitchProps> = ({ name }) => {
  const { t } = useLoginTranslation();
  const { control } = useFormContext();
  const loginParams = useRecoilValue(loginParamsAtom);
  const { isNonProductionLoginColors } = useContext(LoginPageFormContext);
  const radioButtonSx = getRadioButtonLoginSx(isNonProductionLoginColors);
  return (
    <div className="optionsSignIn">
      <Controller
        rules={{ required: true }}
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => (
          <>
            <RadioGroup row {...field}>
              {loginParams?.has(LoginAuthType.Username) && (
                <FormControlLabel
                  onClick={e => e.preventDefault()}
                  value={LoginAuthType.Username}
                  control={<Radio onClick={e => e.stopPropagation()} />}
                  label={t(`login.${LoginAuthType.Username}`)}
                  sx={radioButtonSx}
                />
              )}
              {loginParams?.has(LoginAuthType.Phone) && (
                <FormControlLabel
                  onClick={e => e.preventDefault()}
                  value={LoginAuthType.Phone}
                  control={<Radio onClick={e => e.stopPropagation()} />}
                  label={t(`login.${LoginAuthType.Phone}`)}
                  sx={radioButtonSx}
                />
              )}
              {loginParams?.has(LoginAuthType.Email) && (
                <FormControlLabel
                  onClick={e => e.preventDefault()}
                  value={LoginAuthType.Email}
                  control={<Radio onClick={e => e.stopPropagation()} />}
                  label={t(`login.${LoginAuthType.Email}`)}
                  sx={radioButtonSx}
                />
              )}
            </RadioGroup>
            {/*TODO: add translation key*/}
            {error && <FormHelperText>{error.message}</FormHelperText>}
          </>
        )}
      />
    </div>
  );
};
